import { easyTramMainlandBaseSegmentColorHover  } from '../map/map-drawing-colors';
import { MapComponent } from '../map/map.component';
import {
  SelectionMode,
  SelectionModeHandler,
} from './selection-mode';

/**
 * Generic SelectionMode Handler for EasyTram Tramline selection
 */
export class SelectionModeSegmentHandler extends SelectionModeHandler {

  highlighterHighlightedPath: google.maps.Polyline | undefined;

  override initializeMap(map: MapComponent): SelectionModeHandler {
    return new SelectionModeSegmentHandler(map);
  }

  constructor(map: MapComponent | undefined = undefined) {
    super(SelectionMode.Combination, map);
  }

  override onStartSelectionMode(): void {
  }

  override onAfterRedraw(): void {
  }

  override onExitSelectionMode() {
    this.highlighterHighlightedPath?.setMap(null);
    this.highlighterHighlightedPath = undefined;
  }

  override onMouseUp(event: google.maps.MapMouseEvent): void {
    if (!event.latLng || !this.mapInstance) return;

    // Construct click tolerance based on zoom level to ensure it works well at different zoom levels
    const zoom = this.mapInstance?.map.getZoom() ?? 15; // Default to 15 if undefined
    const tolerance: number = 0.0005 * Math.pow(2, 15 - zoom);

    // Find closest line to click position within tolerance to highlight it
    const line = this.mapInstance?.scenarioData.getLineRefForPosition(event.latLng, tolerance);
    if (line?.lineData) {
      if (line.lineData.easyTramSegmentType === 'mainlandBaseSegment') {
        line.lineData.easyTramSegmentType = 'default';
      } else if (line.lineData.easyTramSegmentType === 'default') {
        // Remove old mainland base segment if existend
        for (const lines of this.mapInstance?.scenarioData.lines || []) {
          for (const otherLine of lines) {
            if (otherLine.lineData?.easyTramSegmentType === 'mainlandBaseSegment' && otherLine.id != line.id) {
              otherLine.lineData.easyTramSegmentType = 'default';
            }
          }
        }
        line.lineData.easyTramSegmentType = 'mainlandBaseSegment';
      }

      this.mapInstance?.dispatchEasytramPlanUpdate();
    }

    this.mapInstance?.dispatchEasytramPlanUpdate();
  }

  override onMouseDown(event: google.maps.MapMouseEvent): void {
  }

  override onMouseMove(event: google.maps.MapMouseEvent): void {
    if (!this.mapInstance || !event.latLng) return;

    // Construct click tolerance based on zoom level to ensure it works well at different zoom levels
    const zoom = this.mapInstance?.map.getZoom() ?? 15; // Default to 15 if undefined
    const tolerance: number = 0.0005 * Math.pow(2, 15 - zoom);

    const line = this.mapInstance?.scenarioData.getLineRefForPosition(event.latLng, tolerance);
    if (line !== undefined) {
      this.mapInstance!.map.setOptions({
        draggable: false,
        draggableCursor:
          'url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAxCAMAAAD6FOlzAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAfVQTFRFAAAA/////////////////////////////////////////////v7+////////////+vr68PDw////////////6Ojo5+fn5ubm////////////z8/P+/v7u7u74uLi/////////////////v7+8vLy0NDQurq63Nzc////////9PT02tra2NjYxMTE1NTU////////////3d3d0dHR////////////zc3N/Pz8////////////xsbGwMDAvr6+ycnJ+/v7////////7u7u0tLS+vr6////////////1tbW+Pj4////////6enpwsLC9vb2////////7Ozsv7+/8/Pz////////8fHx////////+fn51dXVvLy8////////xcXF/Pz809PT6+vr////////////9/f3////////vb29+Pj4////////////39/f7+/v/////f39x8fH5eXl////4+PjyMjI7e3t////9fX1////////////////4eHh////////////////19fX////////////6urq/////////////////////////////////////////////////////////////////////f39////////////////////////////////////////////////////W4ZX2AAAAKd0Uk5TAIgW6O0f/+wlKy5V//E6f///9kOr////+k/W//////1bA/z+//////5p//////+PAYD//6QCqv/+sAXV//////68Cf///scOKv/+0RP////aGv///+Eh/+nU////7zP/////8yQp/8JT//9BY6n//3j///9i////Rf8oVGxg/1K0DNv/l3ky/1w39T89QvldSLP7DU5fWoQs/lAHsgsRxG0XznceQCdkcEq1AAACQklEQVR4nH3T6UMSQRgG8K3o6cJoK8CEtVJ5JUtLrewAyuiwrLCo7KAiLQpTCKnsvk8rssvu+/g7m9lZlnUZfD7wYX7sy7Mzg6LwTJmqTJZpjumTMTBjZmWdBeazK/IcwImquZXYhXlQMX9BBV4INzxeVC+Scw188Gu1WLxEpkvr6rUGBKgRwWXS4k20HB6iFYBLVtxNzWw6UUsQK1fZuRVtRCqbTtRej9VrbLwW7Xwwm07UsQ7rN0zkjQgRheGPcN+0GZ1b7MXZehRbOVNoG7bvsHAXK86yU0wnat6F7t3W4nv4atgpphPtjaFnn8kuXpxlvzGdKH4ABw+ViovlFkRDmvBILw53GXyEF2cJsFM/ekx4IorjJwQD+srJJHhOGd6H/tNcz4ji5NEVKeP3yY2znM+J4tQkGHGD0wM4byneYHC6+HgtBhkP8R1nyQjNFpXacMFSPDzANTdsch4XzR3nfinl7LtsKo3gSql4ea7imqJcN4qXJwd2sDeQkWscDtbsJm7JeRjdjG8jFZGyD3cY372HbELG9/FA3/MqjMg4g4f6iT3qx2OtnD14Ik706ajs5bJ4ZlyI54DXrukUzPv0ooD8BAu4kym8NK/jWKH0+glm7HBieFW6zWOvxe5pPq/fOPhg9ZuSv61Do9aRL5r++DvLn2Wc3VNY4let0xXlPfu+adFe9umw8gfkhCWz6kdgdOjTZysrPdyFFb6Mf1VsaUVMzfLHOwe/2U3/Q/B8//FTYjw1+PX7TwVj+fvPvvIfiIac6lOpRMUAAAAASUVORK5CYII="), auto',
      });


      this.highlighterHighlightedPath?.setMap(null);
      this.highlighterHighlightedPath = undefined;

      this.highlighterHighlightedPath = new google.maps.Polyline({
        clickable: false,
        path: line.line!.getPath(),
        geodesic: true,
        strokeColor: easyTramMainlandBaseSegmentColorHover,
        strokeOpacity: 0.8,
        strokeWeight: 15,
        map: this.mapInstance.map,
        zIndex: 1001,
      });
    } else {
      this.mapInstance!.map.setOptions({
        draggable: true,
        draggableCursor: undefined,
      });

      this.highlighterHighlightedPath?.setMap(null);
      this.highlighterHighlightedPath = undefined;
    }

  }
}
